import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../clients';
import { topSchema } from '../types';

export const receiveTop = createReceive('top', zodContract(topSchema));
